export type FilmOrientation = 'PORTRAIT' | 'LANDSCAPE';
export type FilmSize =
	| 'A4'
	| 'A3'
	| '8INX10IN'
	| '10INX12IN'
	| '14INX17IN'
	| '11INX14IN'
	| '11INX17IN'
	| '14INX14IN'
	| '14INX17IN'
	| '24CMX24CM'
	| '24CMX30CM'
	| 'A4'
	| 'A3';

export interface DicomPrintConfigType {
	dicomPrinterID: number | null;
	filmOrientation: FilmOrientation;
	filmSize: FilmSize;
	dpi: number;
	imagePixelSizeFromFilm: { widthPx: number; heightPx: number };
	endablePrintDicomMode: boolean;
}
export const filmSizeMap: Record<FilmSize, { widthInch: number; heightInch: number }> = {
	A4: { widthInch: 8.27, heightInch: 11.69 },
	A3: { widthInch: 11.69, heightInch: 16.54 },
	'8INX10IN': { widthInch: 8, heightInch: 10 },
	'10INX12IN': { widthInch: 10, heightInch: 12 },
	'14INX17IN': { widthInch: 14, heightInch: 17 },
	'11INX14IN': { widthInch: 11, heightInch: 14 },
	'11INX17IN': { widthInch: 11, heightInch: 17 },
	'14INX14IN': { widthInch: 14, heightInch: 14 },
	'24CMX30CM': { widthInch: 9.44, heightInch: 11.81 },
	'24CMX24CM': { widthInch: 9.44, heightInch: 9.44 },
};

export type PrintDicomConfig = Record<string, DicomPrintConfigType>;
